import { gql } from '@apollo/client';
import type { Geofence } from '@cobliteam/common-types';
import graphQLRequester from '../../request/GraphQLRequester';
import type { GeofenceGraphQLAPI } from './Definitions';
import { geofencesGraphQLTransformer } from './GeofenceTransformer';

export class GrahpQLGeofenceRequester {
  public getGeofences = (): Promise<Geofence[]> => {
    return graphQLRequester
      .query<{ geofences: GeofenceGraphQLAPI[] }>({
        query: gql`
          query GetGeofences {
            geofences {
              id
              name
              fleetId
              createdAt
              category
              geojson {
                properties {
                  address
                  radius
                  coordinate
                }
              }
            }
          }
        `,
      })
      .then((graphQlResponse) => geofencesGraphQLTransformer(graphQlResponse.geofences));
  };
}

export default GrahpQLGeofenceRequester;
